import React, { useState } from 'react';
import { AlertTriangle, BookOpen, Check, ChevronDown, ChevronRight, Loader2 } from 'lucide-react';
import { toolLabel } from '../agentContextMap';
import ApprovalCard from './ApprovalCard';
import FileCard from './FileCard';
import ResultView from './ResultView';

function describeArgs(args) {
  return Object.entries(args || {})
    .filter(([, value]) => value !== undefined && value !== null && value !== '')
    .slice(0, 3)
    .map(([key, value]) => {
      if (Array.isArray(value)) return `${key}: ${value.length}`;
      if (typeof value === 'object') return key;
      const text = String(value);
      return `${key}: ${text.length > 28 ? `${text.slice(0, 27)}…` : text}`;
    })
    .join(' · ');
}

function StepCard({ step, actions, canDecide, onDecide, onUndoAction, onUndoBatch }) {
  const [open, setOpen] = useState(false);

  if (step.approval) {
    return (
      <ApprovalCard step={step} actions={actions} canDecide={canDecide} onDecide={onDecide} onUndoAction={onUndoAction} onUndoBatch={onUndoBatch} />
    );
  }

  const icon =
    step.status === 'running' ? (
      <Loader2 size={14} className="dagent-spin" aria-hidden="true" />
    ) : step.status === 'error' ? (
      <AlertTriangle size={14} aria-hidden="true" />
    ) : step.name === 'load_skill' ? (
      <BookOpen size={14} aria-hidden="true" />
    ) : (
      <Check size={14} aria-hidden="true" />
    );

  return (
    <div className={`dagent-step dagent-step--${step.status}`}>
      <button type="button" className="dagent-step__head" onClick={() => setOpen((value) => !value)} aria-expanded={open}>
        <span className="dagent-step__icon">{icon}</span>
        <span className="dagent-step__label">
          {toolLabel(step.name)}
          {step.skill ? `: ${step.skill}` : ''}
        </span>
        <span className="dagent-step__args">{step.status === 'error' ? 'failed' : describeArgs(step.args)}</span>
        {open ? <ChevronDown size={14} aria-hidden="true" /> : <ChevronRight size={14} aria-hidden="true" />}
      </button>
      {step.status === 'done' && step.result?.fileId && (
        <div className="dagent-step__file">
          <FileCard file={step.result} />
        </div>
      )}
      {open && (
        <div className="dagent-step__body">
          {step.error ? <p className="dagent-step__error">{step.error}</p> : <ResultView result={step.result} tooLarge={step.resultTooLarge} />}
          <details className="dagent-raw">
            <summary>Arguments</summary>
            <pre>{JSON.stringify(step.args, null, 2)}</pre>
          </details>
        </div>
      )}
    </div>
  );
}

export default StepCard;
